<template>

    <div id="search-filter-bar">

        <div class="contents">

            <button type="button" @click="onToggleFilter" class="btn toggle-filter btn--white"><i class="fal fa-fw fa-filter"></i></button>
            <span class="active-filter-count" v-if="totalCriteriaCount > 0">
                {{totalCriteriaCount}}
            </span>
     
            <div :class="{'-selected': locationSelectionDisplay.hasSelection }" @click="onLocationClicked">
                <i class="fal fa-fw fa-map-marker-alt"></i>
                {{locationSelectionDisplay.displayValue}}
            </div>

            <div @click="onDatesClicked" :class="{'-selected': datesSelectionDisplay.hasSelection }">
                <i class="fal fa-fw fa-calendar-alt"></i>
                {{datesSelectionDisplay.displayValue}}
            </div>





            <div @click="onGuestsClicked" :class="{'-selected': guestsSelectionDisplay.hasSelection }">
                <i class="fal fa-fw fa-users"></i>

                {{guestsSelectionDisplay.displayValue}}
            </div>

           
        </div>
    </div>


</template>


<script src="./SearchFilterBarComponent.ts" lang="ts"></script>
<style src="./SearchFilterBarComponent.css"></style>